import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { clearAdminSession } from '../../auth/adminLogout';
import { ADMIN_NAV_LINKS } from './adminNavConfig';

const SIDEBAR = '#0a2a2a';
const ACCENT = '#C8A96A';
const ACCENT_MUTED = 'rgba(200, 169, 106, 0.15)';

export default function AdminSidebar() {
  const navigate = useNavigate();
  const { pathname, hash } = useLocation();
  const [displayUser, setDisplayUser] = useState({ name: 'Admin', email: '' });

  useEffect(() => {
    try {
      const raw = localStorage.getItem('user_data');
      if (raw) {
        const u = JSON.parse(raw);
        setDisplayUser({
          name: u.displayName || u.name || 'Admin',
          email: u.email || '',
        });
      }
    } catch {
      /* ignore */
    }
  }, []);

  const handleLogout = async () => {
    await clearAdminSession();
    navigate('/admin/login');
  };

  return (
    <aside
      className="hidden md:flex w-64 shrink-0 flex-col min-h-screen text-white/90"
      style={{ backgroundColor: SIDEBAR }}
    >
      <div className="p-6 border-b border-white/10">
        <div className="flex items-center gap-2">
          <span className="material-symbols-outlined text-2xl" style={{ color: ACCENT }}>
            chair
          </span>
          <div>
            <p className="font-bold text-white tracking-tight">Jatin Interiors</p>
            <p className="text-[10px] uppercase tracking-widest text-white/50">Admin</p>
          </div>
        </div>
      </div>

      <p className="px-6 pt-5 pb-2 text-[10px] uppercase tracking-widest text-white/40 font-semibold">Navigation</p>
      <nav className="flex-1 px-3 space-y-0.5">
        {ADMIN_NAV_LINKS.map((item) => {
          const active = item.isActive(pathname, hash);
          return (
            <Link
              key={item.label}
              to={item.to}
              className={`flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm transition-colors ${
                active ? 'bg-white/10 text-white border-l-2' : 'text-white/65 hover:bg-white/5 hover:text-white'
              }`}
              style={active ? { borderLeftColor: ACCENT } : { borderLeft: '2px solid transparent' }}
            >
              <span className="material-symbols-outlined text-xl opacity-90">{item.icon}</span>
              {item.label}
            </Link>
          );
        })}
      </nav>

      <div className="p-4 border-t border-white/10 mt-auto">
        <p className="text-[10px] uppercase tracking-widest text-white/40 font-semibold px-1 mb-3">User account</p>
        <div className="flex items-center gap-3 px-2 py-2 rounded-xl bg-black/20">
          <div
            className="w-10 h-10 rounded-full flex items-center justify-center text-sm font-bold shrink-0"
            style={{ backgroundColor: ACCENT_MUTED, color: ACCENT }}
          >
            {displayUser.name.charAt(0).toUpperCase()}
          </div>
          <div className="min-w-0">
            <p className="text-sm font-medium text-white truncate">{displayUser.name}</p>
            <p className="text-xs text-white/50 truncate">{displayUser.email || 'Administrator'}</p>
          </div>
        </div>
        <button
          type="button"
          onClick={handleLogout}
          className="mt-3 w-full flex items-center justify-center gap-2 py-2.5 rounded-lg text-sm font-medium bg-white/10 hover:bg-white/15 text-white/90 transition-colors"
        >
          <span className="material-symbols-outlined text-lg">logout</span>
          Sign out
        </button>
      </div>
    </aside>
  );
}
